<template>
  <div class="discounts-page">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>
    <div class="column-right">
      <div v-if="admin_datos.superadmin" class="main-container">
        <div class="page-header">
          <div>
            <h2>Descuentos de solicitudes de pago</h2>
            <p>Reglas para codigos, UTM y tipos de solicitud.</p>
          </div>
          <button class="btn btn-primary" @click="newRule">Nueva regla</button>
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <div v-if="loading" class="loading-box">Cargando...</div>

        <div class="content-grid">
          <section class="rules-list">
            <div
              v-for="rule in discounts"
              :key="rule.id"
              class="rule-row"
              :class="{ inactive: !rule.activo }"
            >
              <div>
                <div class="rule-title">
                  {{ rule.nombre }}
                  <span v-if="rule.codigo" class="code-pill">{{ rule.codigo }}</span>
                </div>
                <div class="rule-meta">
                  {{ modalidadLabel(rule.modalidad) }} | {{ valueLabel(rule) }} | {{ fundingLabel(rule.funding) }}
                </div>
                <div class="rule-meta">
                  Prioridad {{ rule.prioridad || 0 }} | {{ rule.activo ? 'Activa' : 'Inactiva' }}
                </div>
                <div class="rule-meta">
                  {{ usageLimitLabel(rule.max_usos_por_orden) }}
                </div>
              </div>
              <div class="row-actions">
                <button class="btn btn-secondary" @click="editRule(rule)">Editar</button>
                <button class="btn btn-secondary" @click="toggleRule(rule)">
                  {{ rule.activo ? 'Desactivar' : 'Activar' }}
                </button>
              </div>
            </div>
            <p v-if="!loading && discounts.length === 0" class="empty-text">
              No hay descuentos configurados.
            </p>
          </section>

          <section v-if="editing" class="editor">
            <h3>{{ form.id ? 'Editar regla' : 'Nueva regla' }}</h3>

            <label>Nombre</label>
            <input v-model="form.nombre" class="form-control" />

            <label>Codigo opcional</label>
            <input v-model="form.codigo" class="form-control" placeholder="ej: primavera10" />

            <div class="two-cols">
              <div>
                <label>Modalidad</label>
                <select v-model="form.modalidad" class="form-control">
                  <option value="monto_fijo">Monto fijo</option>
                  <option value="porcentaje">Porcentaje</option>
                  <option value="porcentaje_con_tope">Porcentaje con tope</option>
                  <option value="gratis">Gratis</option>
                </select>
              </div>
              <div>
                <label>Funding</label>
                <select v-model="form.funding" class="form-control">
                  <option value="jobbing">Jobbing</option>
                  <option value="profesional">Profesional</option>
                  <option value="mixto">Mixto</option>
                </select>
              </div>
            </div>

            <div class="three-cols">
              <div>
                <label>Valor</label>
                <input v-model.number="form.valor" type="number" class="form-control" />
              </div>
              <div>
                <label>Tope</label>
                <input v-model.number="form.tope" type="number" class="form-control" />
              </div>
              <div>
                <label>Minimo compra</label>
                <input v-model.number="form.monto_minimo" type="number" class="form-control" />
              </div>
            </div>

            <div class="three-cols">
              <div>
                <label>Prioridad</label>
                <input v-model.number="form.prioridad" type="number" class="form-control" />
              </div>
              <div>
                <label>Usos por orden</label>
                <input v-model.number="form.max_usos_por_orden" type="number" min="0" class="form-control" />
              </div>
              <div>
                <label>Inicio</label>
                <input v-model="form.fecha_inicio" type="datetime-local" class="form-control" />
              </div>
            </div>
            <p class="hint">Usos por orden: 1 permite usarlo solo una vez por orden; 0 lo deja sin limite.</p>

            <div class="two-cols">
              <div>
                <label>Termino</label>
                <input v-model="form.fecha_termino" type="datetime-local" class="form-control" />
              </div>
            </div>

            <label>Texto publico</label>
            <input v-model="form.texto_publico" class="form-control" placeholder="Ej: Tu descuento ya esta disponible." />

            <h4>Activadores</h4>
            <p class="hint">Separar multiples valores con coma. Deja vacio si no aplica.</p>
            <div class="two-cols">
              <div>
                <label>UTM source</label>
                <input v-model="activators.utm_source" class="form-control" />
              </div>
              <div>
                <label>UTM medium</label>
                <input v-model="activators.utm_medium" class="form-control" />
              </div>
              <div>
                <label>UTM campaign</label>
                <input v-model="activators.utm_campaign" class="form-control" />
              </div>
              <div>
                <label>Categoria ID</label>
                <input v-model="activators.categoria_id" class="form-control" />
              </div>
              <div>
                <label>Clase</label>
                <input v-model="activators.clase" class="form-control" />
              </div>
              <div>
                <label>Empresa ID</label>
                <input v-model="activators.empresa_id" class="form-control" />
              </div>
              <div>
                <label>Estado orden</label>
                <input v-model="activators.orden_estado" class="form-control" />
              </div>
            </div>

            <label class="check-row">
              <input v-model="form.activo" type="checkbox" />
              Activo
            </label>

            <div class="editor-actions">
              <button class="btn btn-primary" @click="saveRule">Guardar</button>
              <button class="btn btn-secondary" @click="cancelEdit">Cancelar</button>
            </div>
          </section>
        </div>
      </div>
      <div v-else class="main-container">
        <p>No tienes permisos para acceder a esta seccion.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import TopNav from '@/components/TopNav.vue'
import SideNav from '@/components/SideNav.vue'

const emptyForm = () => ({
  id: null,
  nombre: '',
  codigo: '',
  activo: true,
  fecha_inicio: '',
  fecha_termino: '',
  prioridad: 0,
  max_usos_por_orden: 1,
  modalidad: 'monto_fijo',
  valor: 0,
  tope: null,
  monto_minimo: 0,
  funding: 'jobbing',
  texto_publico: ''
})

const emptyActivators = () => ({
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  categoria_id: '',
  clase: '',
  empresa_id: '',
  orden_estado: ''
})

export default {
  name: 'Descuentos',
  components: {
    TopNav,
    SideNav
  },
  data () {
    return {
      discounts: [],
      loading: false,
      error: '',
      editing: false,
      form: emptyForm(),
      activators: emptyActivators()
    }
  },
  computed: {
    ...mapGetters(['admin_datos'])
  },
  created () {
    this.fetchDiscounts()
  },
  methods: {
    async fetchDiscounts () {
      this.loading = true
      this.error = ''
      try {
        const resp = await axios.get(window.hostname + 'api/superadmin/descuentos')
        this.discounts = resp.data.descuentos || []
      } catch (e) {
        this.error = 'No se pudieron cargar los descuentos.'
      } finally {
        this.loading = false
      }
    },
    newRule () {
      this.form = emptyForm()
      this.activators = emptyActivators()
      this.editing = true
    },
    editRule (rule) {
      this.form = {
        id: rule.id,
        nombre: rule.nombre || '',
        codigo: rule.codigo || '',
        activo: !!rule.activo,
        fecha_inicio: this.toLocalDateInput(rule.fecha_inicio),
        fecha_termino: this.toLocalDateInput(rule.fecha_termino),
        prioridad: rule.prioridad || 0,
        max_usos_por_orden: rule.max_usos_por_orden == null ? 1 : rule.max_usos_por_orden,
        modalidad: rule.modalidad || 'monto_fijo',
        valor: rule.valor || 0,
        tope: rule.tope,
        monto_minimo: rule.monto_minimo || 0,
        funding: rule.funding || 'jobbing',
        texto_publico: rule.texto_publico || ''
      }
      this.activators = this.activatorsToForm(rule.activadores || {})
      this.editing = true
    },
    cancelEdit () {
      this.editing = false
      this.form = emptyForm()
      this.activators = emptyActivators()
    },
    async saveRule () {
      this.error = ''
      const payload = {
        ...this.form,
        codigo: this.form.codigo || null,
        tope: this.form.tope === '' ? null : this.form.tope,
        max_usos_por_orden: this.form.max_usos_por_orden == null ? 1 : Math.max(Number(this.form.max_usos_por_orden) || 0, 0),
        activadores: this.formActivatorsToPayload()
      }
      try {
        if (this.form.id) {
          await axios.put(window.hostname + `api/superadmin/descuentos/${this.form.id}`, payload)
        } else {
          await axios.post(window.hostname + 'api/superadmin/descuentos', payload)
        }
        await this.fetchDiscounts()
        this.cancelEdit()
      } catch (e) {
        this.error = e.response && e.response.data && e.response.data.message
          ? e.response.data.message
          : 'No se pudo guardar el descuento.'
      }
    },
    async toggleRule (rule) {
      try {
        await axios.post(window.hostname + `api/superadmin/descuentos/${rule.id}/estado`, {
          activo: !rule.activo
        })
        await this.fetchDiscounts()
      } catch (e) {
        this.error = 'No se pudo cambiar el estado.'
      }
    },
    toLocalDateInput (value) {
      if (!value) return ''
      return String(value).slice(0, 16)
    },
    activatorsToForm (activadores) {
      const result = emptyActivators()
      Object.keys(result).forEach(key => {
        const value = activadores[key]
        result[key] = Array.isArray(value) ? value.join(', ') : (value || '')
      })
      return result
    },
    formActivatorsToPayload () {
      const payload = {}
      Object.keys(this.activators).forEach(key => {
        const items = String(this.activators[key] || '')
          .split(',')
          .map(item => item.trim())
          .filter(Boolean)
        if (items.length) payload[key] = items
      })
      return payload
    },
    modalidadLabel (value) {
      const labels = {
        monto_fijo: 'Monto fijo',
        porcentaje: 'Porcentaje',
        porcentaje_con_tope: 'Porcentaje con tope',
        gratis: 'Gratis'
      }
      return labels[value] || value
    },
    fundingLabel (value) {
      const labels = {
        jobbing: 'Absorbe Jobbing',
        profesional: 'Absorbe profesional',
        mixto: 'Mixto'
      }
      return labels[value] || value
    },
    valueLabel (rule) {
      if (rule.modalidad === 'gratis') return '100%'
      if (rule.modalidad === 'porcentaje' || rule.modalidad === 'porcentaje_con_tope') {
        return `${rule.valor}%${rule.tope ? ' tope $' + Number(rule.tope).toLocaleString('es-CL') : ''}`
      }
      return `$${Number(rule.valor || 0).toLocaleString('es-CL')}`
    },
    usageLimitLabel (value) {
      const limit = Number(value == null ? 1 : value)
      return limit <= 0 ? 'Sin limite por orden' : `Maximo ${limit} por orden`
    }
  }
}
</script>

<style scoped>
.discounts-page {
  text-align: left;
}
.column-right {
  margin-left: 240px;
  padding: 88px 28px 40px;
}
.main-container {
  max-width: 1240px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
}
.page-header h2 {
  margin: 0;
  font-weight: 700;
}
.page-header p {
  margin: 6px 0 0;
  color: #64748b;
}
.content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 460px);
  gap: 24px;
  align-items: start;
}
.rules-list,
.editor {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 18px;
}
.rule-row {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 0;
  border-bottom: 1px solid #eef2f7;
}
.rule-row:last-child {
  border-bottom: 0;
}
.rule-row.inactive {
  opacity: 0.58;
}
.rule-title {
  font-weight: 700;
  color: #0f172a;
}
.rule-meta,
.hint,
.empty-text {
  color: #64748b;
  font-size: 0.9rem;
}
.code-pill {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 0.78rem;
}
.row-actions,
.editor-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.editor label {
  display: block;
  margin-top: 12px;
  margin-bottom: 5px;
  font-weight: 600;
  color: #334155;
}
.form-control {
  width: 100%;
  min-height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 8px 10px;
  box-sizing: border-box;
}
.two-cols,
.three-cols {
  display: grid;
  gap: 12px;
}
.two-cols {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.three-cols {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.check-row {
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.btn {
  border: none;
  border-radius: 8px;
  padding: 9px 13px;
  font-weight: 700;
  cursor: pointer;
}
.btn-primary {
  background: #2563eb;
  color: #fff;
}
.btn-secondary {
  background: #f1f5f9;
  color: #0f172a;
}
.alert {
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 14px;
}
.alert-danger {
  background: #fef2f2;
  color: #991b1b;
}
.loading-box {
  color: #64748b;
  margin-bottom: 12px;
}
@media (max-width: 900px) {
  .column-right {
    margin-left: 0;
    padding: 86px 16px 32px;
  }
  .content-grid {
    grid-template-columns: 1fr;
  }
}
</style>
